<div [formGroup]="formGroup" class="form-group row">
    <div class="col-12">
        <h5 class="my-3 text-mad text-uppercase">
            Location
        </h5>
        <hr class="active" />
    </div>
    <div class="col-12">
        <div class="row">
            <div class="col-8">
                <!-- BEGIN: Search -->
                <div class="row">
                    <div class="col-12">
                        <div class="search">
                            <mat-form-field class="mat-form-field-fluid">
                                <input 
                                    #searchByLocation
                                    matInput
                                    type="text"
                                    placeholder="Search by Location"
                                    autocorrect="off"
                                    autocapitalize="off"
                                    spellcheck="off"
                                />
                                <mat-icon
                                    matSuffix
                                    class="cursor-pointer"
                                    container="body"
                                    ngbPopover="Right click anywhere on the map to pin-point your property."
                                    popoverTitle="Locate"
                                >
                                    help
                                </mat-icon>
                            </mat-form-field>
                            <mat-form-field class="mat-form-field-fluid">
                                <input matInput placeholder="Search by GPS" [formControl]="gpsSearchControl" />
                            </mat-form-field>
                            <mat-checkbox [formControl]="useAsAddressControl">
                                Use as property address
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <!-- END -->

                <!-- BEGIN: Map -->
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngIf="mapViewModel$|async as vm">
                            <agm-map
                                [usePanning]="true"
                                [clickableIcons]="false"
                                [scrollwheel]="false"
                                [latitude]="vm.center.lat"
                                [longitude]="vm.center.lng"
                                [zoom]="vm.zoom"
                                (mapReady)="onMapReady($event)"
                            >
                                <agm-map-type-control></agm-map-type-control>
                                <ng-container *ngIf="vm.marker">
                                    <agm-marker
                                        [latitude]="vm.marker.latitude"
                                        [longitude]="vm.marker.longitude"
                                    >
                                    </agm-marker>
                                </ng-container>
                            </agm-map>
                            <mat-error *ngIf="coordinatesRequired" [matErrorState]="formGroup.controls['latitude']">
                                Location <strong>required</strong> (right-click to define location)
                            </mat-error>
                        </ng-container>
                    </div>
                </div>
                <!-- END -->
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="unit" placeholder="Unit" />
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="building_name" placeholder="Building Name" />
                        </mat-form-field>
                    </div>
                    <ng-container *ngFor="let control of formGroup.controls.street_form_array.controls; let i = index">
                        <div class="col-10">
                            <mat-form-field class="mat-form-field-fluid">
                                <input matInput [formControl]="control" placeholder="Street"  />
                            </mat-form-field>
                        </div>
                        <div class="col-2 d-flex">
                            <button type="button" mat-icon-button color="primary" (click)="onAddStreet()">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                            <button *ngIf="formGroup.controls.street_form_array.controls.length > 1" type="button" mat-icon-button (click)="onRemoveStreet(i)" color="warn">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                    <div class="col-12" *ngIf="showSubCommunity">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="sub_community" placeholder="Sub-community" />
                        </mat-form-field>
                    </div>
                    <ng-container *ngFor="let control of formGroup.controls.locality_form_array.controls; let i = index">
                        <div class="col-10">
                            <mat-form-field class="mat-form-field-fluid">
                                <input matInput [formControl]="control" placeholder="Locality / Neighbourhood / Community"  />
                            </mat-form-field>
                        </div>
                        <div class="col-2 d-flex">
                            <button type="button" mat-icon-button color="primary" (click)="onAddLocality()">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                            <button *ngIf="formGroup.controls.locality_form_array.controls.length > 1" type="button" mat-icon-button (click)="onRemoveLocality(i)" color="warn">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                    <div class="col-12">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls.city_id">
                            <mat-select placeholder="City" formControlName="city_id">
                                <mat-option *ngFor="let city of (cities$|async)" [value]="city.id">
                                    {{ city.name }}
                                </mat-option>
                                <mat-hint [formFieldHintState]="formGroup.controls.city_id">
                                    City <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    City <strong>required</strong>
                                </mat-error>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <ng-container *ngFor="let control of formGroup.controls.administrative_area_form_array.controls; let i = index">
                        <div class="col-10">
                            <mat-form-field class="mat-form-field-fluid">
                                <input matInput [formControl]="control" placeholder="Administrative area / Region / State"  />
                            </mat-form-field>
                        </div>
                        <div class="col-2 d-flex">
                            <button type="button" mat-icon-button color="primary" (click)="onAddAdministrativeArea()">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                            <button *ngIf="formGroup.controls.administrative_area_form_array.controls.length > 1" type="button" mat-icon-button (click)="onRemoveAdministrativeArea(i)" color="warn">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                    <!-- Zipcode hidden
                    <div class="col-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="zip_code" placeholder="Zipcode" />
                        </mat-form-field>
                    </div>
                    -->
                    <div class="col-12">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="formGroup.controls.country_id">
                            <mat-select placeholder="Country" formControlName="country_id">
                                <mat-option *ngFor="let country of (countries$|async)" [value]="country.id">
                                    {{ country.name }}
                                </mat-option>
                                <mat-hint [formFieldHintState]="formGroup.controls.country_id">
                                    Country <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    Country <strong>required</strong>
                                </mat-error>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <mat-form-field class="mat-form-field-fluid">
                    <textarea matInput rows="4" formControlName="location_surrounding" placeholder="Location and Surroundings Description"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>